import {client} from '@predict/DomainsLib/backend'

export function startLoginProcess() {
  return client.dfLoginFlow.startLoginProcess()
}

export function startLogoutProcess() {
  return client.dfLoginFlow.startLogoutProcess()
}
